module.exports = __webpack_public_path__ + "img/60.7b08eba2.svg";